import React from 'react';
import _ from 'lodash';

import {
  InventoryActivity_ItemTabDocument,
  InventoryActivity_ItemTabQuery,
  SaveItemPriceMutation,
  useSaveItemPriceMutation
} from 'generated/graphql';

import Big from 'big.js';
import * as types from './types';
import { gqlCacheUtil } from 'modules';



export function useSaveItemPrice(itemId: string) {
  const [fnMutate, tuple] = useSaveItemPriceMutation({
    refetchQueries: []
  });

  const fnWrappedMutate = React.useCallback(
    async (formState: types.IFormState, isListingPrice: boolean) => {
      const price = new Big(formState.priceDollars).toFixed(2);
      await fnMutate({
        variables: {
          input: {
            itemId,
            defaultPriceDollars: isListingPrice ? price : undefined,
            defaultWholesalePriceDollars: isListingPrice ? undefined : price,
            overwriteExistingPrices: formState.overwriteExistingPrices
          }
        },
        updateQueries: gqlCacheUtil.genUpdateQueryMap<InventoryActivity_ItemTabQuery, SaveItemPriceMutation>(
          InventoryActivity_ItemTabDocument,
          (previousState: InventoryActivity_ItemTabQuery, { mutationResult }) => ({
            ...previousState,
            items: {
              ...previousState.items,
              nodes: _.map(previousState.items.nodes, node => {
                if (node.id === mutationResult.data?.saveItem?.id) {
                  return {
                    ...node,
                    ...(mutationResult.data.saveItem ?? {})
                  };
                }
                return node;
              })
            }
          })
        )
      });
    },
    [
      fnMutate,
      itemId
    ]
  );

  return React.useMemo(
    () => [
      fnWrappedMutate,
      {
        ...tuple,
        data: null
      }
    ] as const,
    [
      fnWrappedMutate,
      tuple
    ]
  );
}
